import { render, staticRenderFns } from "./relevantList.vue?vue&type=template&id=42ba2525"
import script from "./relevantList.vue?vue&type=script&lang=js"
export * from "./relevantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports